// custom typefaces
import "typeface-montserrat";
import "typeface-merriweather";
import "typeface-nunito";
import "typeface-alegreya";

import "./src/styles/global.css";
require("prismjs/themes/prism-funky.css"); // or any other theme like 'prism-okaidia.css'
